import { isArray } from 'util';
import { OperatorGroupPlanning, OperatorWeek, OperatorWeeklyPlanning, OperatorWeekShift } from '../operator-planning';
import { OperatorGroupBuilder } from './operator-group.builder';

export class OperatorPlanningBuilder {
  static weekFromJson(json) {
    return (json) ? new OperatorWeek(json.year, json.week, json.startDate, json.endDate) : null;
  }

  static weekShiftFromJson(json) {
    return (json) ? new OperatorWeekShift(json.week, json.shift || '') : null;
  }

  static groupFromJson(json) {
    return (json)
      ? new OperatorGroupPlanning(
        OperatorGroupBuilder.fromJson(json.operatorGroup),
        (isArray(json.shifts)) ? json.shifts.map(OperatorPlanningBuilder.weekShiftFromJson) : [],
      )
      : null;
  }

  static fromJson(json) {
    return (json)
      ? new OperatorWeeklyPlanning(
        json.year,
        json.workingModelGroupHash,
        (isArray(json.weeks)) ? json.weeks.map(OperatorPlanningBuilder.weekFromJson) : [],
        (isArray(json.groups)) ? json.groups.map(OperatorPlanningBuilder.groupFromJson) : [],
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operator-planning.builder.ts